// src/components/Hero.jsx
import { useState, useRef, useEffect } from "react";
import TrustedFormCapture from "../components/TrustedFormCapture";

const INSERT_URL = "https://masstortplaintiffs.com/api/insert.php";

const CASES = [
  { label: "Baby Formula NEC Lawsuits", slug: "baby-formula-nec" },
  { label: "RoundUp Cancer Lawsuits", slug: "roundup-cancer" },
  { label: "Chemical Hair Relaxers and Straighteners Cancer", slug: "hair-relaxer-cancer" },
  { label: "Paraquat Herbicide Lawsuits", slug: "paraquat-parkinsons" },
  { label: "Lung Cancer Asbestos Lawsuit", slug: "asbestos-lung-cancer" },
  { label: "PFAS Water Contamination Lawsuits", slug: "pfas-water" },
  { label: "Los Angeles Wildfire", slug: "la-wildfire" },
  { label: "Silicosis Lawsuit", slug: "silicosis" },
  { label: "Oxbryta Lawsuits", slug: "oxbryta" },
  { label: "Bard PowerPort Catheter Lawsuits", slug: "bard-powerport" },
  { label: "Hernia Mesh Lawsuits", slug: "hernia-mesh" },
  { label: "Ozempic and Wegovy Lawsuits", slug: "ozempic-wegovy" },
  { label: "Depo Provera Lawsuits", slug: "depo-provera" },
  { label: "Suboxone Lawsuit", slug: "suboxone" },
  { label: "Dupixent Lawsuit", slug: "dupixent" },
  { label: "Auto Accident and Personal Injury Lawsuits", slug: "auto-accident-personal-injury" },
  { label: "Social Security Disability Benefits (SSDI) Applications", slug: "ssdi-applications" },
  { label: "Birth Injury Lawyers", slug: "birth-injury" },
  { label: "Video Game Addiction Lawsuits", slug: "video-game-addiction" },
  { label: "LDS Mormon Church Abuse Lawsuit", slug: "lds-abuse" },
  { label: "Roblox & Discord Child Abuse Lawsuit", slug: "roblox-discord-child-abuse" },
  { label: "Rideshare Abuse and Assault Lawsuits", slug: "rideshare-assault" },
  { label: "Snapchat Addiction Lawsuit", slug: "snapchat-addiction" },
];

export default function Hero() {
  const formRef = useRef(null);

  // states
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const [caseSlug, setCaseSlug] = useState("");
  const [caseLabel, setCaseLabel] = useState("");
  const ddRef = useRef(null);

  const [pageSource, setPageSource] = useState("");
  const [ipAddress, setIpAddress] = useState("");

  useEffect(() => {
    setPageSource(window.location.href);
  }, []);

  // Fetch IP
  useEffect(() => {
    async function getIP() {
      try {
        const r = await fetch("https://api.ipify.org?format=json");
        const j = await r.json();
        setIpAddress(j.ip || "");
      } catch {
        setIpAddress("");
      }
    }
    getIP();
  }, []);

  // close dropdown on outside click
  useEffect(() => {
    function onClick(e) {
      if (ddRef.current && !ddRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const selectCase = (slug, label) => {
    setCaseSlug(slug);
    setCaseLabel(label);
    setOpen(false);
  };

  // === MAIN SUBMIT HANDLER ===
  const onSubmit = async (e) => {
    e.preventDefault();

    if (!caseSlug) {
      alert("Please select your case type.");
      return;
    }

    setLoading(true);

    const fd = new FormData(e.target);

    // add correct backend names
    fd.append("tort_type", caseLabel);
    fd.append("page_url", pageSource);
    fd.append("ip_address", ipAddress);
    fd.append("form_type", "HeroForm");

    try {
      const res = await fetch(INSERT_URL, {
        method: "POST",
        body: fd,
      });

      const text = await res.text();
      console.log("insert.php →", text);

      if (text.includes("1") || text.toLowerCase().includes("success")) {
        setSuccess(true);
      } else {
        alert("Insert Error: " + text);
      }
    } catch (err) {
      alert("Network Error: " + err.message);
    }

    setLoading(false);
  };

  return (
    <section
      id="home"
      className="relative text-white -mt-px scroll-mt-16"
      style={{
        backgroundImage:
          "linear-gradient(rgba(10,10,10,.75), rgba(10,10,10,.92)), url('https://images.unsplash.com/photo-1521587760476-6c12a4b040da?q=80&w=1600&auto=format&fit=crop')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-10 items-center">

          {/* LEFT TEXT */}
          <div>
            <span className="inline-block bg-[#C89B3C] text-white font-bold uppercase text-xs rounded-full px-3 py-1 mb-4">
              Nationwide Attorneys
            </span>
            <h1 className="font-serif text-4xl md:text-5xl font-semibold leading-tight">
              Attorneys Fighting for Your Justice
            </h1>
            <p className="text-white/80 mt-4 md:max-w-xl">
              We connect victims to top national law firms for mass tort cases. No upfront fees — you pay only if we win.
            </p>
          </div>

          {/* RIGHT FORM */}
          <div id="form" className="relative bg-black/70 border border-white/10 rounded-2xl p-6">
            <h3 className="font-serif text-2xl font-semibold">Free Case Evaluation</h3>
            <p className="text-white/60 text-sm mt-1">Takes less than a minute.</p>

            <form ref={formRef} onSubmit={onSubmit} className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">

              {/* Correct new backend names */}
              <input name="first_name" placeholder="First name" className="bg-slate-900 border border-white/10 rounded-lg px-3 py-2" required />
              <input name="last_name" placeholder="Last name" className="bg-slate-900 border border-white/10 rounded-lg px-3 py-2" required />
              <input type="tel" name="phone" placeholder="Phone" className="bg-slate-900 border border-white/10 rounded-lg px-3 py-2" required />
              <input type="email" name="email" placeholder="Email" className="bg-slate-900 border border-white/10 rounded-lg px-3 py-2" required />

              {/* Hidden TF fields */}
              <input type="hidden" name="trusteformcerturl" />
              <input type="hidden" name="trustedformtoken" />
              <input type="hidden" name="trustedformpingurl" />

              <TrustedFormCapture
                certField="trusteformcerturl"
                tokenField="trustedformtoken"
                pingField="trustedformpingurl"
              />

              {/* Case selector */}
              <div ref={ddRef} className="md:col-span-2 relative">
                <button
                  type="button"
                  onClick={() => setOpen(!open)}
                  className="w-full bg-slate-900 border border-white/10 rounded-lg px-3 py-2 flex items-center justify-between"
                >
                  <span className={caseLabel ? "" : "text-white/60"}>
                    {caseLabel || "Select your case type"}
                  </span>
                  <span>▾</span>
                </button>

                {open && (
                  <ul className="absolute left-0 right-0 mt-1 max-h-60 overflow-y-auto bg-slate-900 border border-white/10 rounded-lg z-50">
                    {CASES.map((c) => (
                      <li key={c.slug}>
                        <button
                          type="button"
                          onClick={() => selectCase(c.slug, c.label)}
                          className={`w-full px-3 py-2 text-left hover:bg-slate-800 ${
                            caseSlug === c.slug ? "bg-slate-800" : ""
                          }`}
                        >
                          {c.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Submit button */}
              {success ? (
                <button
                  type="button"
                  className="md:col-span-2 bg-green-600 text-white font-semibold px-4 py-2 rounded-lg"
                >
                  Thanks for Submitting!
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={loading}
                  className="md:col-span-2 bg-[#C89B3C] text-white font-semibold px-4 py-2 rounded-lg"
                >
                  {loading ? "Submitting..." : "Submit My Details"}
                </button>
              )}

            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
